import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('medical_benefits_set_review', '/medical_benefits_set_reviews', 'review')
const reducer = generator.generate()

export default reducer
